











import { Component, Vue, Ref, Prop, Watch } from "vue-property-decorator";
import { tns } from "tiny-slider/src/tiny-slider";

@Component
export default class CardSlider extends Vue {
    @Prop({ default: () => [] }) cards!: any;

    @Ref() readonly cardSlider!: HTMLElement;

    slider: any = null;

    mounted() {
        this.$nextTick(() => {
            this.initSlider();
        });
    }

    private initSlider() {
        this.$nextTick(() => {
            if (!this.cardSlider) {
                return;
            }

            // @ts-nocheck
            this.slider = tns({
                container: this.cardSlider,
                gutter: 24,
                items: 1.1,
                preventScrollOnTouch: "force",
                mouseDrag: true,
                loop: false,
                controls: false,
                swipeAngle: false,
                nav: false,
                responsive: {
                    768: {
                        items: 2.1,

                        gutter: 24
                    }
                }
            });
        });
    }
}
